import { keyBy } from 'lodash-es'

export const useSummaries = defineStore('summaries', () => {
  const { $api } = useNuxtApp()
  const userSummaries = ref(null)

  const userSummariesByKey = computed(() => keyBy(userSummaries.value, 'slug'))

  const store = useBaseStore('summaries/exam')

  async function getUserSummary () {
    try {
      const { certifications: data } = await $api.get('/user/summary')
      userSummaries.value = data
    } catch (e) {
      throw createError({
        statusCode: 404
      })
    }
  }

  return {
    ...store,
    getUserSummary,
    userSummaries,
    userSummariesByKey
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSummaries, import.meta.hot))
}
